'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import classNames from 'classnames';
import { useState } from 'react';
import { AButton } from '../AButton';
import { AImage } from '../AImage';
import { AListItem } from '../AListItem';
import styles from './m-e-auto-tariff-card.module.scss';
export const MEAutoTariffCard = ({ className, customerSwitchLabel, existingCustomerActionButton, existingCustomerHeadline, existingCustomerInfoDialogButton, existingCustomerList, existingCustomerSubheadline, icon, footnote, newCustomerActionButton, newCustomerHeadline, newCustomerInfoDialogButton, newCustomerList, newCustomerSubheadline })=>{
    const [isExistingCustomer, setIsExistingCustomer] = useState(false);
    const headline = isExistingCustomer ? existingCustomerHeadline : newCustomerHeadline;
    const subheadline = isExistingCustomer ? existingCustomerSubheadline : newCustomerSubheadline;
    const dialogButton = isExistingCustomer ? existingCustomerInfoDialogButton?.[0] : newCustomerInfoDialogButton?.[0];
    const actionButton = isExistingCustomer ? existingCustomerActionButton?.[0] : newCustomerActionButton?.[0];
    const list = isExistingCustomer ? existingCustomerList?.[0]?.items : newCustomerList?.[0]?.items;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.card, className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    icon?.length === 1 && /*#__PURE__*/ _jsx(AImage, {
                        className: styles.icon,
                        ...icon[0]
                    }),
                    headline && /*#__PURE__*/ _jsx(Headline, {
                        renderAs: "h3",
                        size: "s",
                        children: headline
                    }),
                    subheadline && /*#__PURE__*/ _jsx(Headline, {
                        className: styles.subheadline,
                        renderAs: "h4",
                        size: "s",
                        children: subheadline
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles['switch-wrapper'],
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        bold: true,
                        renderAs: "h5",
                        size: "xs",
                        children: customerSwitchLabel
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: classNames(styles['switch-input'], !isExistingCustomer && styles['switch-input-right-active']),
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: classNames(styles['switch-button'], isExistingCustomer && styles['switch-button-active']),
                                onClick: ()=>setIsExistingCustomer(true),
                                children: "Ja"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: classNames(styles['switch-button'], !isExistingCustomer && styles['switch-button-active']),
                                onClick: ()=>setIsExistingCustomer(false),
                                children: "Nein"
                            })
                        ]
                    })
                ]
            }),
            Boolean(list?.length) && /*#__PURE__*/ _jsx("ul", {
                className: styles.list,
                children: list?.map((props)=>/*#__PURE__*/ _jsx(AListItem, {
                        ...props
                    }, props._uid))
            }),
            Boolean(footnote) && /*#__PURE__*/ _jsx(Text, {
                size: "xs",
                children: footnote
            }),
            (dialogButton || actionButton) && /*#__PURE__*/ _jsxs("div", {
                className: styles.footer,
                children: [
                    dialogButton && /*#__PURE__*/ _jsx(AButton, {
                        hasNoIcon: true,
                        ...dialogButton,
                        isSlim: true,
                        variant: "link"
                    }),
                    actionButton && /*#__PURE__*/ _jsx(AButton, {
                        ...actionButton,
                        children: actionButton.text
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=MEAutoTariffCard.js.map